import {
  Box,
  List,
  ListItemButton,
  ListItemText,
  Typography,
  Chip,
} from '@mui/material';
import type { VariantListItem } from '@src/types';

interface VariantsListProps {
  items: VariantListItem[];
  selectedSku: string | null;
  onSelect: (sku: string) => void;
  productName?: string;
}

/**
 * Left column of the 2-column variant editor.
 * Shows a scrollable list of all variant SKUs (Color / Size format).
 */
const VariantsList = ({ items, selectedSku, onSelect, productName }: VariantsListProps) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
        {productName && (
          <Typography variant="subtitle1" fontWeight={600} noWrap>
            {productName}
          </Typography>
        )}
        <Chip
          label={`${items.length} Variants`}
          size="small"
          sx={{ mt: 0.5 }}
        />
      </Box>
      <List sx={{ overflow: 'auto', flex: 1, py: 0 }}>
        {items.map(item => (
          <ListItemButton
            key={item.sku}
            selected={selectedSku === item.sku}
            onClick={() => onSelect(item.sku)}
            sx={{ py: 0.75 }}
          >
            <ListItemText
              primary={`${item.colorDisplay} / ${item.sizeDisplay}`}
              primaryTypographyProps={{
                variant: 'body2',
                fontWeight: selectedSku === item.sku ? 700 : 400,
              }}
            />
          </ListItemButton>
        ))}
      </List>
    </Box>
  );
};

export default VariantsList;
